<mat-card class="mat-typography">
  <mat-checkbox [checked]="block.checkboxSlot.value" (change)="block.toggle()">
    <span markdown [content]="name" [context]="context" [required]="block.required" lineBreaks="false"></span>
  </mat-checkbox>
  <mat-card-footer *ngIf="explanation" markdown [content]="explanation" [context]="context"> </mat-card-footer>
</mat-card>
